import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '~/lib/api';
import type { CreateNoteInput } from '~shared/schemas';

/**
 * Один хук — один ресурс/операция.
 * Queries: useXxx() → useQuery.
 * Mutations: useCreateXxx/useUpdateXxx/... → useMutation + invalidateQueries по нужным ключам.
 */

const KEYS = {
  all: ['notes'] as const,
  one: (id: number) => ['notes', id] as const,
};

export function useNotes() {
  return useQuery({
    queryKey: KEYS.all,
    queryFn: api.notes.list,
  });
}

export function useNote(id: number) {
  return useQuery({
    queryKey: KEYS.one(id),
    queryFn: () => api.notes.get(id),
    enabled: Number.isInteger(id) && id > 0,
  });
}

export function useCreateNote() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateNoteInput) => api.notes.create(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEYS.all });
    },
  });
}
